<template>
<div class="course_video">
  <ul>
    <li class="video_item"
      v-for="video in videos" :key="video.id"
      @click="goVideo(video)">
      <!-- <img :src="video.cover" class="thumbnail"> -->
      <div :class="['content', {'current': currentVideo.id === video.id}]">
        <h4 class="title">{{video.title}}</h4>
        <span class="sub_title">{{video.totalDuration | timeChange}}</span>
      </div>
    </li>
    <li v-if="videos.length === 0" class="no_video">
      <p>暂无视频</p>
    </li>
  </ul>
</div>
</template>
<script>
import { mapState } from 'vuex'
import sensorHelp from '@/vendor/sensors/help'
import { RECORD_VIDEO_CHOOSE } from '@/constant/sensorEvent'
export default {
  inject: ['reload'],
  props: {
    videos: {
      type: Array,
      default () {
        return []
      },
    },
    course: {
      type: Object,
      default () {
        return {}
      },
    },
  },
  computed: {
    ...mapState('course', ['currentVideo']),
  },
  filters: {
    timeChange (value) {
      let hours = parseInt(value / 3600)
      let minutes = parseInt(value / 60 - hours * 60)
      let seconds = value - minutes * 60 - hours * 3600
      return `${hours.toLocaleString(undefined, { minimumIntegerDigits: 2 })}:${minutes.toLocaleString(undefined, { minimumIntegerDigits: 2 })}:${seconds.toLocaleString(undefined, { minimumIntegerDigits: 2 })}`
    },
  },
  data () {
    return {
      courseList: [],
    }
  },
  methods: {
    goVideo (video) {
      this.reload()
      let courseId = this.$route.params.courseId
      this.$router.push({ name: 'VideoDetail', params: { courseId, videoId: video.id } })
      sensorHelp.track(RECORD_VIDEO_CHOOSE, {
        school_course_id: this.course.id,
      })
    },
  },
}
</script>

<style lang="scss">
.course_video {
  padding-top: 64px;
  height: 100%;
  overflow-y: scroll;
  font-size: 14px;
  .video_item {
    position: relative;
    display: flex;
    cursor: pointer;
    padding: 16px;
    &:hover {
      .content {
        color: #ed6c00;
        .sub_title {
          color: #ed6c00;
        }
      }
    }
    &:after {
      content: '';
      width: 90%;
      height: 1px;
      background: #d8d8d8;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%)
    }
  }
  .content {
    width: 100%;
    padding: 0 8px;
    transition: all .2s;
    &.current {
      color: #ed6c00;
      .sub_title {
        color: #ed6c00;
      }
    }
    .title {
      line-height: 1.5;
      word-break: break-all;
    }
    .sub_title {
      font-size: 12px;
      color: #777;
      transition: all .2s;
    }
  }
  .thumbnail {
    width: 128px;
    height: 80px;
    border-radius: 4px;
    flex-shrink: 0;
  }
  .no_video {
    padding: 20px;
    text-align: center;
  }
}
</style>
